// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3nn1E","calendarButtons":"ClockData_calendarButtons__EMMPb"};